// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueResource from 'vue-resource';
import VueSession from 'vue-session';
import VueCookies from 'vue-cookies';
import 'babel-polyfill';

// font awesome libs
import * as FontAwesome from '@fortawesome/fontawesome-svg-core';
import {
  faClipboard,
  faTh,
  faSlidersH,
  faFlag,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faAngleUp,
  faTimesCircle,
  faTimes,
  faFilter,
  faSearch,
  faFileExport,
  faPrescriptionBottle,
  faChartPie,
  faFileAlt,
  faVials,
  faArrowRight,
  faCloudDownloadAlt,
  faFilePdf,
  faCog,
  faUsers,
  faPlus,
  faLock,
  faEllipsisH,
  faBan,
  faPlusCircle,
  faUserLock,
  faEnvelope,
  faPlusSquare,
  faMinusSquare,
  faCheckCircle,
  faExclamationCircle,
  faMinusCircle,
  faPencilAlt,
  faSpinner,
  faFileCsv,
  faPhone,
  faExternalLinkAlt
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);

import router from './router';
import App from './App.vue';

Vue.use(VueResource);
Vue.use(require('vue-moment'));

Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(VueSession, {
  persist: true
});

// more fontawesome stuff
FontAwesome.library.add(
  faClipboard,
  faTh,
  faSlidersH,
  faFlag,
  faAngleRight,
  faAngleLeft,
  faAngleDown,
  faAngleUp,
  faTimesCircle,
  faTimes,
  faFilter,
  faSearch,
  faFileExport,
  faPrescriptionBottle,
  faChartPie,
  faFileAlt,
  faVials,
  faArrowRight,
  faCloudDownloadAlt,
  faFilePdf,
  faCog,
  faUsers,
  faPlus,
  faPlusCircle,
  faLock,
  faEllipsisH,
  faBan,
  faUserLock,
  faEnvelope,
  faPlusSquare,
  faMinusSquare,
  faCheckCircle,
  faExclamationCircle,
  faMinusCircle,
  faPencilAlt,
  faSpinner,
  faFileCsv,
  faEnvelope,
  faPhone,
  faExternalLinkAlt
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  data: {
    API_ENDPOINT: process.env.API_ENDPOINT
  }
});


// WEBPACK FOOTER //
// ./src/main.js